import { FormattedMessage } from 'react-intl';
import * as React from 'react';
import type { TModifiedRankinScaleRating } from 'neuro-schemas/modifiedRankinScale';
import { arrayOfAll } from 'neuro-utils';

export const opts = arrayOfAll.options<TModifiedRankinScaleRating>()([0, 1, 2, 3, 4, 5, 6]);

export const optFormatter = (n: string | number): React.JSX.Element => (
  <FormattedMessage id={`functionalPerformance.opts.modifiedRankinScale.rating.${n}`} />
);
